const Home = '/';

const routes = {
  Home,
  ManageLocks: '/manage-locks',
};

export default routes;



// WEBPACK FOOTER //
// ./src/config/routes.js